export default {
  welcome: "Hello World"
}
